// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"styles_buttonContainer__pQqJl","tokenButton":"styles_tokenButton__cW5e7"};